import React from 'react'

import Setting from 'components/Setting'

const SettingPage: React.FC = () => {
  return <Setting />
}

export default SettingPage
